











import _ from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { NAME } from './constants';
import { store } from '../store/edit';


export default EditStoreMixin.extend({
	name: `${NAME}Card`,
	data() {
		return {
			NAME,
			visibleColumns: new Set([
				'KOD_KOREKCE',
				'TEXT',
				'OC',
			]),
		};
	},
	computed: {
		...genVuexComputeds(store),
		table(): any {
			const copy = _.cloneDeep(this.dependentTables.ZakazkaKorekce);
			copy && _.forEach(copy.columns, (col) => {
				col.isVisible = this.visibleColumns.has(col.columnName);
			});
			return copy;
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		name(): string {
			return NAME;
		},
	},
	methods: {
		showList() {
			openList(NAME, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		createClickFunc() {
			openEdit(NAME, PageMode.CREATE, { props: true, filter: { ZakazkaId: this.ZakazkaId } });
		},
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { props: true, id: event.data.ID });
		},
	},
});
